import { useTheme as useNextTheme, ThemeProvider as NextThemeProvider } from 'next-themes'
import { useRouter } from 'next/router'
import { PropsWithChildren } from 'react'

import { useUserThemeQuery } from '~generated/hooks'
import { Theme } from '~generated/types'
import useCookie from '~lib/hooks/useCookie'
import { Navigation } from '~lib/routes'

export const userThemeToNextThemeMap = {
  [Theme.DARK]: 'dark',
  [Theme.LIGHT]: 'light',
}

export const nextThemeToUserThemeMap = {
  dark: Theme.DARK,
  light: Theme.LIGHT,
}

function UserThemeProvider({ children }: PropsWithChildren) {
  const { setTheme } = useNextTheme()

  const cookie = useCookie()
  const router = useRouter()
  useUserThemeQuery({
    skip: !cookie?.userId || Navigation.isPublicRoute(router),
    variables: { id: cookie?.userId },
    fetchPolicy: 'cache-and-network',
    onCompleted: (data) => {
      if (data?.user?.theme && userThemeToNextThemeMap[data.user.theme]) {
        setTheme(userThemeToNextThemeMap[data.user.theme])
      }
    },
  })

  return <>{children}</>
}

export default function ThemeProvider({ children }: PropsWithChildren) {
  return (
    <NextThemeProvider disableTransitionOnChange enableSystem={false} defaultTheme="dark">
      <UserThemeProvider>{children}</UserThemeProvider>
    </NextThemeProvider>
  )
}
